var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, useCallback } from 'react';
import _ from 'lodash';
import classnames from 'classnames/bind';
import analyseData from '../../../utils/analyseData';
import Filter from '../../../utils/filter';
import QuickSearchInput from '../QuickSearchInput';
import ToggleFilter from '../../ToggleFilter';
import FilterDropdown from '../../FilterDropdown';
import FilterResult from '../../FilterResult';
import style from './index.module.scss';
import instance from '../../../services/httpRequest';
import Loading from '../../Loading';
import localesReplacement from '../../../utils/localesReplacement';
import { useDebounce } from 'use-debounce';
var cx = classnames.bind(style);
var classDropdownItem = 'dropdown-item';
function quickSearch(value, isPersonalizedLicensePlate, userType, country, signal) {
    if (userType === void 0) { userType = false; }
    var window = globalThis;
    return instance
        .get("/quickSearch?text=".concat(encodeURIComponent(value)).concat(isPersonalizedLicensePlate ? "&isPersonalizedLicensePlate=true" : ""), {
        signal: signal
    })
        .then(function (d) {
        var _a, _b, _c;
        var event = ((_a = d.data) === null || _a === void 0 ? void 0 : _a.length) > 0
            ? "quickSearches"
            : "detailsUnavailable_quickSearches";
        var searchQuery = ((_b = d.data) === null || _b === void 0 ? void 0 : _b.length) > 0 && !((_c = d.data[0]) === null || _c === void 0 ? void 0 : _c.model)
            ? "licensePlateSearch"
            : encodeURIComponent(value);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: event,
            searchType: "quick search",
            pageType: "product finder",
            searchQuery: searchQuery,
            userType: userType ? "workshop owner" : "vehicle owner",
            countryCode: country,
        });
        return d;
    });
}
function QuickSearch(props) {
    var onVehicleSelect = props.onVehicleSelect, replacements = props.replacements, country = props.country, switchVehicleSearch = props.switchVehicleSearch, licence = props.licence, licensePlateRegexes = props.licensePlateRegexes, selectedWorkshop = props.selectedWorkshop, restore = props.restore, preserved = props.preserved, userType = props.userType, captcha = props.captcha, language = props.language;
    var _a = useState(false), filterVisible = _a[0], setFilterVisible = _a[1];
    var _b = useState([]), vehicleTypes = _b[0], setVehicleTypes = _b[1];
    var _c = useState(''), vehicleType = _c[0], setVehicleType = _c[1];
    var _d = useState(''), make = _d[0], setMake = _d[1];
    var _e = useState(''), model = _e[0], setModel = _e[1];
    var _f = useState(''), year = _f[0], setYear = _f[1];
    var _g = useState(''), searchKey = _g[0], setSearchKey = _g[1];
    var _h = useState([]), results = _h[0], setResults = _h[1];
    var _j = useState(false), isMount = _j[0], setIsMount = _j[1];
    var _k = useState(false), finish = _k[0], setFinish = _k[1];
    var _l = useState(false), isPersonalizedLicensePlate = _l[0], setIsPersonalizedLicensePlate = _l[1];
    var controller = new AbortController();
    var regExp = new RegExp(licensePlateRegexes).test(searchKey);
    var debounceKey = useDebounce(searchKey, 1000)[0];
    //Get licence search params from API
    useEffect(function () {
        return function () {
            _.unset(instance.defaults.headers, 'Authorization');
            setResults([]);
        };
    }, []);
    useEffect(function () {
        memoAutocompleted(debounceKey);
    }, [debounceKey]);
    /* Quick search input change & clear function */
    var changeHandler = function (value, token) {
        if (captcha && licence) {
            if (token) {
                _.assign(instance.defaults.headers, {
                    Authorization: "Captcha ".concat(token),
                });
            }
            else {
                _.unset(instance.defaults.headers, 'Authorization');
                setResults([]);
                return;
            }
        }
        if (_.trim(value).length >= 3) {
            setIsMount(true);
        }
        setSearchKey(value);
        restore && sessionStorage.setItem('searchKey', value);
        setIsPersonalizedLicensePlate(false);
    };
    var memoAutocompleted = useCallback(function (value, isPersonalizedLicensePlate) {
        if (isPersonalizedLicensePlate === void 0) { isPersonalizedLicensePlate = false; }
        if (_.trim(value).length >= 3) {
            setFinish(false);
            setIsMount(true);
            selectedWorkshop
                ? _.assign(instance.defaults.headers, {
                    isWorkshopOwner: selectedWorkshop,
                })
                : _.unset(instance.defaults.headers, 'isWorkshopOwner');
            quickSearch(value, isPersonalizedLicensePlate, userType, country, controller.signal).then(function (d) {
                if (_.inRange(d.status, 200, 300)) {
                    setVehicleTypes(analyseData.vehicleTypeFormat(d.data));
                    setResults(d.data);
                }
                setIsMount(false);
                setFinish(true);
            });
        }
        else {
            setIsMount(false);
            setFinish(false);
            setFilterVisible(false);
            setResults([]);
        }
        setVehicleType('');
        setMake('');
        setModel('');
        setYear('');
    }, [selectedWorkshop]);
    var clearQuickSearch = function () {
        setSearchKey('');
        memoAutocompleted('');
    };
    /* Vehicle Type dropdown change */
    var changeVehicleType = function (vehicleType) {
        setVehicleType(vehicleType);
        setMake('');
        setModel('');
        setYear('');
        restore && sessionStorage.setItem('searchQType', vehicleType);
    };
    /* Manufacturer dropdown change */
    var changeMake = function (make) {
        setMake(make);
        setModel('');
        setYear('');
        restore && sessionStorage.setItem('searchQType', vehicleType);
    };
    /* Model dropdown change */
    var changeModel = function (model) {
        setModel(model);
        setYear('');
        restore && sessionStorage.setItem('searchQType', vehicleType);
    };
    var searchByPlate = function () {
        memoAutocompleted(searchKey, true);
        setIsPersonalizedLicensePlate(true);
    };
    useEffect(function () {
        memoAutocompleted(searchKey);
        setResults([]);
        setVehicleType('');
        setMake('');
        setModel('');
        setYear('');
    }, [selectedWorkshop]);
    useEffect(function () {
        var _a;
        if (preserved) {
            setSearchKey((_a = sessionStorage.getItem('searchKey')) !== null && _a !== void 0 ? _a : '');
        }
    }, [preserved]);
    useEffect(function () {
        var _a, _b, _c, _d;
        if (preserved && results) {
            setVehicleType((_a = sessionStorage.getItem('searchQType')) !== null && _a !== void 0 ? _a : '');
            setMake((_b = sessionStorage.getItem('searchQMake')) !== null && _b !== void 0 ? _b : '');
            setModel((_c = sessionStorage.getItem('searchQmodel')) !== null && _c !== void 0 ? _c : '');
            setYear((_d = sessionStorage.getItem('searchQYear')) !== null && _d !== void 0 ? _d : '');
        }
    }, [preserved, results]);
    var SEARCHFORNUMBERPLATE = (_jsxs("div", __assign({ className: 'guide' }, { children: [_jsx("div", __assign({ className: 'infor' }, { children: _jsxs("p", { children: [localesReplacement(replacements, 'No results found for'), _jsx("strong", { children: _.trim(searchKey) }, void 0)] }, void 0) }), void 0), _jsxs("div", __assign({ className: 'guide-block' }, { children: [_jsxs("p", { children: [localesReplacement(replacements, 'If'), _jsx("strong", { children: _.trim(searchKey) }, void 0), localesReplacement(replacements, 'is a personalised license plate, try clicking Search by Number plate below.')] }, void 0), _jsxs("div", __assign({ className: 'buttons' }, { children: [_jsx("button", __assign({ className: 'primary', onClick: searchByPlate }, { children: localesReplacement(replacements, 'Search by the Number plate') }), void 0), _jsx("button", __assign({ onClick: clearQuickSearch }, { children: localesReplacement(replacements, 'Start New Search') }), void 0)] }), void 0)] }), void 0)] }), void 0));
    var EMPTYFORNUMBERPLATE = (_jsxs("div", __assign({ className: 'guide guide-empty' }, { children: [_jsx("div", __assign({ className: 'infor' }, { children: _jsxs("p", { children: [localesReplacement(replacements, 'No results found for'), _jsx("strong", { children: _.trim(searchKey) }, void 0), localesReplacement(replacements, '. Try searching using the Vehicle Search')] }, void 0) }), void 0), _jsx("div", __assign({ className: 'guide-block' }, { children: _jsxs("div", __assign({ className: 'buttons' }, { children: [_jsx("button", __assign({ className: 'primary', onClick: switchVehicleSearch }, { children: localesReplacement(replacements, 'Vehicle Search') }), void 0), _jsx("button", __assign({ onClick: clearQuickSearch }, { children: localesReplacement(replacements, 'Start New Search') }), void 0)] }), void 0) }), void 0)] }), void 0));
    var renderNoMatch = function () {
        return finish &&
            _.trim(searchKey).length >= 3 &&
            (!_.isEqual(country, "USA") && licence ? (_jsx("div", __assign({ className: "no-match" }, { children: isPersonalizedLicensePlate || regExp
                    ? EMPTYFORNUMBERPLATE
                    : SEARCHFORNUMBERPLATE }), void 0)) : (_jsx("div", __assign({ className: "no-match" }, { children: EMPTYFORNUMBERPLATE }), void 0)));
    };
    var renderResults = function () {
        return (!_.isEmpty(results) ? (_jsxs(_Fragment, { children: [_jsx(ToggleFilter, { toggleHandler: setFilterVisible, panelVisible: filterVisible }, void 0), _jsx("div", __assign({ className: cx('dropdown-list', "".concat(licence ? 'licence' : '')) }, { children: results.length > 1 && (_jsxs(_Fragment, { children: [!!vehicleTypes && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: cx(classDropdownItem, {
                                            hidden: !filterVisible,
                                        }) }, { children: _jsx(FilterDropdown, { dataList: analyseData.vehicleType(vehicleTypes), filter: vehicleType, changeHandler: changeVehicleType, type: localesReplacement(replacements, 'Vehicle Type'), replacements: replacements }, void 0) }), void 0), _jsx("div", __assign({ className: cx(classDropdownItem, {
                                            hidden: !filterVisible,
                                        }) }, { children: _jsx(FilterDropdown, { dataList: vehicleType
                                                ? analyseData.make(vehicleTypes, vehicleType)
                                                : analyseData.getMake(vehicleTypes), filter: make, changeHandler: changeMake, type: localesReplacement(replacements, 'Make'), replacements: replacements }, void 0) }), void 0), _jsx("div", __assign({ className: cx(classDropdownItem, {
                                            hidden: !filterVisible,
                                        }) }, { children: _jsx(FilterDropdown, { dataList: analyseData.model(vehicleTypes, vehicleType, make), filter: model, changeHandler: changeModel, type: localesReplacement(replacements, 'Model'), replacements: replacements }, void 0) }), void 0)] }, void 0)), !!results && (_jsx(_Fragment, { children: _jsx("div", __assign({ className: cx(classDropdownItem, {
                                        hidden: !filterVisible,
                                    }) }, { children: _jsx(FilterDropdown, { dataList: analyseData.getYear(new Filter(results)
                                            .vehicleType(vehicleType)
                                            .manufacturer(make)
                                            .model(model)
                                            .value()), filter: year, changeHandler: function (v) {
                                            setYear(v);
                                            restore && sessionStorage.setItem('searchQYear', v);
                                        }, type: localesReplacement(replacements, 'Year'), replacements: replacements }, void 0) }), void 0) }, void 0))] }, void 0)) }), void 0), _jsx(FilterResult, { dataList: results, vehicleType: vehicleType, make: make, model: model, year: year, sort: true, value: searchKey, onSelect: onVehicleSelect, replacements: replacements }, void 0)] }, void 0)) : renderNoMatch());
    };
    return (_jsxs(_Fragment, { children: [_jsx(QuickSearchInput, { value: searchKey, onChangeHandler: changeHandler, onClearHandler: clearQuickSearch, licence: licence, captcha: captcha, replacements: replacements, country: country, language: language }, void 0), !isMount ? renderResults() : _jsx(Loading, {}, void 0)] }, void 0));
}
export default QuickSearch;
